/**
 * PostHog capture. Pass the client from usePostHog() so call sites
 * work when PostHog is disabled (client is undefined).
 * Use capture(posthog, eventName, properties) throughout the app for easier search/review.
 */

export type PostHogClient =
  | { capture: (event: string, properties?: Record<string, unknown>) => void }
  | undefined;

export function capture(
  posthog: PostHogClient,
  eventName: string,
  properties?: Record<string, unknown>
) {
   if (process.env.NODE_ENV === "development") {
    console.log("[PostHog capture]", eventName, properties ?? {});
  } else if (posthog) {
    posthog.capture(eventName, properties);
  }
}
